/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import { message} from 'antd';



class BankAccountDetails extends Component {
	fattJs = null;

	constructor(props) {
	  super(props);
	};

	UNSAFE_componentWillMount = () => {
	  const stax_public_apikey = this.props.stax_public_apikey || null;

	  if (stax_public_apikey) {
		  const FattJs = window.FattJs;

		  const fattJs = new FattJs(stax_public_apikey, {
	      bankAccountNumber: {
	        id: "ach_bank_account_name",
	        placeholder: "Bank Account",
	        style: "width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
	      },
	      routingNumber: {
	        id: "ach_routing_number",
	        placeholder: "Routing Number",
	        style: "width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
	      },
	      accountNumber: {
	        id: "ach_account_number",
	        placeholder: "Account Number",
	        style: "width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
	      }
		  });
		  fattJs.showCardForm().then(handler => {
	      console.log('form loaded', handler);
		  }).catch(err => {
	      console.error('error occur', err);
		  });

		  this.fattJs = fattJs;
	    this.props.setFattJs(fattJs);

	  } else {
		  message.error('Error occur while loading stax. please contact to admin.', 10);
	  }
	}

	// Render Bank Account Inputs
    renderBankAccountDetails = () =>
    {
      const { errors } = this.props;

      return <div className="credit_card_form">
       
        <div> Bank Account <span style={{ color: "red" }}>*</span>
          <input
    		    type="text"
            id="ach_bank_account_name"
            placeholder="Bank Account"
            className="form--control item"
            disabled = {this.props.displayBank === false}
            style={{ height: 50, border: '2px solid #E6E6E6' }}
            onChange={(e) => { this.props.onBankCardInfoChange({ach_bank_account_name: e.target.value }) }}
          />
          {
            errors && errors['bank_account_info.ach_bank_account_name'] ? 
              <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['bank_account_info.ach_bank_account_name']}</label> 
              : ''
          }
        </div>
        <div className='item special-item' >
          <div className='half_size_items mm-yyyy' style={{ width: '100%' }}>
            <div className='routing_field'> Routing Number <span style={{ color: "red" }}>*</span>
              <input
                id="ach_routing_number"
                type="text"
                className="form--control"
                placeholder="Routing Number"
                maxLength={9} 
                style={{marginTop: '5px'}}
                disabled = {this.props.displayBank === false}
                inputMode="numeric"
                onPaste={(event) => {
                  if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                    event.preventDefault();
                  }
                }}
                onKeyPress={(e) => {
                  const pattern = /[0-9]/;
                  const inputChar = String.fromCharCode(e.charCode);
                  if (!pattern.test(inputChar)
                  ) {
                    // invalid character, prevent input
                    e.preventDefault();
                  }
                }}
                onChange={(e) => { this.props.onBankCardInfoChange({ach_routing_number: e.target.value }) }}
              />
              {
                errors && errors['bank_account_info.ach_routing_number'] ?
                  <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['bank_account_info.ach_routing_number']}</label>
                  : ''
              }
            </div>

            <div> Account Number <span style={{ color: "red" }}>*</span>
              <input
                id="ach_account_number"
                name="account-number"
                type="text"
                placeholder="Account Number"
                className="form--control"
                maxLength={15} 
                style={{marginTop: '5px'}}
                disabled = {this.props.displayBank === false}
                inputMode="numeric"
                onPaste={(event) => {
                  if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                    event.preventDefault();
                  }
                }}
                onKeyPress={(e) => {
                  const pattern = /[0-9]/;
                  const inputChar = String.fromCharCode(e.charCode);
                  if (!pattern.test(inputChar)
                  ) {
                    // invalid character, prevent input
                    e.preventDefault();
                  }
                }}
                onChange={(e) => { this.props.onBankCardInfoChange({ ach_account_number: e.target.value }) }}
              />
              {
                errors && errors['bank_account_info.ach_account_number'] ?
                  <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['bank_account_info.ach_account_number']}</label>
                  : ''
              }
            </div>
          </div>
        </div>
        <div className='item special-item'>
          <div className='half_size_items mm-yyyy' style={{ width: '100%' }}>
            <div className="account_types" > Account Type <span style={{ color: "red" }}>*</span>
              <div className='account_type' style={{marginTop: '5px'}}>
                <div className='checking_account_type'>
                  <input
                    type="radio"
                    id = "checking_account_type"
                    name = "account_type"
                    // className="form--control"
                    style={{marginRight: '15px'}}
                            
                    disabled = {this.props.displayBank === false}
                    onChange={(e) => { this.props.onBankCardInfoChange({ ach_account_type: 'checking' }) }}
                  /> Checking
                </div>
                
                <div className='savings_account_type'>
                  <input
                    type="radio"
                    id = "savings_account_type"
                    name = "account_type"
                    disabled = {this.props.displayBank === false}
                    // className="form--control"
                    style={{marginRight: '15px'}}
                    onChange={(e) => { this.props.onBankCardInfoChange({ ach_account_type: 'savings'}) }}
                  /> Savings
                  
                </div>
              </div>
              {
                errors && errors['bank_account_info.ach_account_type'] ?
                  <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['bank_account_info.ach_account_type']}</label>
                  : ''
              }
						
            </div>

            <div className="bank_holder_type"> Bank Holder Type <span style={{ color: "red" }}>*</span>
              <div className='bank_holder_types' style={{marginTop: '5px'}}>
                <div className='personal_bank_holder_type'>
                  <input
                    id="personal_bank_holder_type"
                    name="bank_holder_type"
                    type="radio"
                    style={{marginRight: '15px'}}
                    // className="form--control"
                    disabled = {this.props.displayBank === false}
                    onChange={(e) => { this.props.onBankCardInfoChange({ ach_bank_holder_type: 'personal' }) }}
                  />Personal
                </div>

                <div className='business_bank_holder_type'>
                  <input
                    id="business_bank_holder_type"
                    name="bank_holder_type"
                    type="radio"
                    style={{marginRight: '15px'}}
                    disabled = {this.props.displayBank === false}
                    onChange={(e) => { this.props.onBankCardInfoChange({ ach_bank_holder_type: 'business' }) }}
                  />Business
                </div>
              </div>
              {
                errors && errors['bank_account_info.ach_bank_holder_type'] ?
                  <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['bank_account_info.ach_bank_holder_type']}</label>
                  : ''
              }
            </div>
          </div>
        </div>  
      </div>
    }

    render ()
    {
      const {checked_permissions_ach} = this.props;
        
      return <React.Fragment>
        {this.renderBankAccountDetails()}
        
        <div
          className="checkbox_wrapper"
          style={{
            justifyContent: "flex-start",
    				width: "100%",
    				marginTop: "10px"
          }}
        >
          <input
            id={'checked_permissions_ach'}
            type="checkbox"
            checked={checked_permissions_ach}
            style={{marginRight: "15px"}}
            onChange={(e) => {
              this.props.onChangeBankDetailsCheckbox(e.target.checked)
            }}
          />
          <label htmlFor={checked_permissions_ach}>
            By Selecting this box I grant permission for Doody Calls to charge my bank account on a monthly basis.
          </label>
        </div>
      </React.Fragment>
    }
}

export default BankAccountDetails;
